import { SsoClient } from "@formant/core/client/SsoClient";
import { ISsoConfiguration } from "@formant/core/model/ISsoConfiguration";
import { Uuid } from "@formant/core/model/Uuid";

import { IAuthStore } from "./IAuthStore";
import { ISsoStore } from "./ISsoStore";
import { StoreCache } from "./StoreCache";
import { updateList } from "./utils/UpdateList";

export class SsoStore implements ISsoStore {
    private ssoListConfig = new StoreCache<undefined, ISsoConfiguration[]>();

    private ssoConfig = new StoreCache<string, ISsoConfiguration | undefined>();

    constructor(
        private ssoClient: SsoClient,
        private authStore: IAuthStore,
    ) {}

    listAll(): ISsoConfiguration[] | undefined {
        return this.ssoListConfig.get(undefined, async () =>
            this.ssoClient.list(await this.authStore.token()),
        );
    }

    getSso(id: Uuid): ISsoConfiguration | undefined {
        return this.ssoConfig.get(id, async () => await this.fetchGet(id));
    }

    async createSso(query: ISsoConfiguration) {
        const createdSso = await this.ssoClient.createSso(
            await this.authStore.token(),
            query,
        );
        if (createdSso.id) {
            this.ssoConfig.set(createdSso.id, createdSso);

            const currentSsoConfigList = this.ssoListConfig.peek(undefined);
            if (currentSsoConfigList) {
                this.ssoListConfig.set(
                    undefined,
                    updateList(currentSsoConfigList, createdSso),
                );
            }
        }
    }

    async updateSso(query: Partial<ISsoConfiguration>) {
        const updatedSso = await this.ssoClient.updateSso(
            await this.authStore.token(),
            query,
        );

        if (updatedSso.id) {
            this.ssoConfig.set(updatedSso.id, updatedSso);

            const currentSsoConfigList = this.ssoListConfig.peek(undefined);
            if (currentSsoConfigList) {
                this.ssoListConfig.set(
                    undefined,
                    updateList(currentSsoConfigList, updatedSso),
                );
            }
        }
    }

    private async fetchGet(id: Uuid): Promise<ISsoConfiguration | undefined> {
        const organization = await this.ssoClient.get(
            await this.authStore.token(),
            id,
        );
        const value = organization;
        this.ssoConfig.set(id, value);
        return value;
    }
}
